import { render, staticRenderFns } from "./NovaOrganizacao.vue?vue&type=template&id=0c1decf5"
import script from "./NovaOrganizacao.vue?vue&type=script&lang=js"
export * from "./NovaOrganizacao.vue?vue&type=script&lang=js"
import style0 from "./NovaOrganizacao.vue?vue&type=style&index=0&id=0c1decf5&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports